import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { ConfigSection, GameProfile, type Menu, ProfileCtx } from "./types";

const createMenu = (ctx: ProfileCtx): Menu => {
  const menu = defaultProfile(ctx).menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const configSections: ConfigSection[] = [{ component: "ConfSection", props: { name: "general" } }];

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(_ctx),
  configSections,
});
